import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  arrayUnion,
  getDoc
} from 'firebase/firestore';
import './UsuariosESelos.css';

function UsuariosESelos({ selosExistentes }) {
  const [usuarios, setUsuarios] = useState([]);
  const [seloSelecionado, setSeloSelecionado] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [filtroTexto, setFiltroTexto] = useState("");
  const [ordenarPor, setOrdenarPor] = useState("pontos");
  const [modoFiltro, setModoFiltro] = useState("");
  const [pontosMinimos, setPontosMinimos] = useState("");
  const [pontosTotaisMinimos, setPontosTotaisMinimos] = useState("");
  const [porcentagemMinima, setPorcentagemMinima] = useState("");

  useEffect(() => {
    async function carregarUsuarios() {
      try {
        const snap = await getDocs(collection(db, "usuarios"));

        // Busca pontos de todos os usuários em paralelo
        const lista = await Promise.all(
          snap.docs.map(async (docSnap) => {
            const dados = docSnap.data();
            const uid = docSnap.id;
            let pontosData = {};

            try {
              const pontosRef = doc(db, "ranking", "usuarios", uid, "pontos");
              const pontosSnap = await getDoc(pontosRef);

              if (pontosSnap.exists()) {
                const dataPontos = pontosSnap.data();

                // Itera sobre os modos, exceto a chave "total"
                Object.entries(dataPontos).forEach(([modo, valor]) => {
                  if (
                    modo !== "total" &&
                    valor &&
                    typeof valor === "object" &&
                    valor.pontosmodo !== undefined
                  ) {
                    // Converter Firestore Timestamp para milissegundos
                    let ultimaAtualizacaoMs = null;
                    if (valor.ultimaAtualizacao) {
                      if (typeof valor.ultimaAtualizacao.toDate === "function") {
                        // Firestore Timestamp
                        ultimaAtualizacaoMs =
                          valor.ultimaAtualizacao.toDate().getTime();
                      } else {
                        // String ou número
                        const tmp = new Date(valor.ultimaAtualizacao);
                        ultimaAtualizacaoMs = isNaN(tmp.getTime())
                          ? null
                          : tmp.getTime();
                      }
                    }

                    pontosData[modo] = {
                      pontos: valor.pontosmodo,
                      porcentagem: valor.porcentagem || "0.0",
                      // guardamos sempre como número (timestamp em ms)
                      ultimaAtualizacao: ultimaAtualizacaoMs,
                    };
                  }
                });
              }
            } catch (erroPontos) {
              console.warn(`⚠️ Erro ao buscar pontos de ${uid}:`, erroPontos);
            }

            return {
              uid,
              nome: dados.nome || "",
              sobrenome: dados.sobrenome || "",
              email: dados.email || "",
              total: dados.pontuacao || 0,
              pontosPorModo: pontosData,
              selos: dados.selosGanhos || []
            };
          })
        );

        setUsuarios(lista);
      } catch (erro) {
        console.error("Erro ao carregar usuários:", erro);
      }
    }

    carregarUsuarios();
  }, []);

  async function atribuirSelo(uid) {
    if (!seloSelecionado) {
      setMensagem("Seleciona um selo antes de atribuir.");
      return;
    }

    try {
      const ref = doc(db, "usuarios", uid);
      await updateDoc(ref, {
        selosGanhos: arrayUnion(seloSelecionado),
        selooficial: seloSelecionado
      });

      setMensagem(`✅ Selo "${seloSelecionado}" atribuído a ${uid}`);
    } catch (erro) {
      console.error("Erro ao atribuir selo:", erro);
      setMensagem("❌ Ocorreu um erro ao atribuir o selo.");
    }
  }

  // helper para pegar a data mais antiga entre todos os modos de um usuário
  function getDataMaisAntigaDeTodosOsModos(pontosPorModo) {
    let menor = null;

    Object.values(pontosPorModo || {}).forEach((dados) => {
      if (dados && typeof dados.ultimaAtualizacao === "number") {
        if (menor === null || dados.ultimaAtualizacao < menor) {
          menor = dados.ultimaAtualizacao;
        }
      }
    });

    // se não tiver nenhuma, volta 0 para não quebrar a ordenação
    return menor ?? 0;
  }

  return (
    <div className="usuarios-selos-container">
      <h2>Atribuir selos a usuários</h2>

      <div className="barra-controles-usuarios">
        <label className="seletor-selo">
          Selecionar selo:
          <select
            value={seloSelecionado}
            onChange={(e) => setSeloSelecionado(e.target.value)}
          >
            <option value="">-- Escolher selo --</option>
            {selosExistentes.map((s) => (
              <option key={s.id} value={s.id}>
                {s.nome}
              </option>
            ))}
          </select>
        </label>

        <label className="filtro-texto">
          Procurar utilizador:
          <input
            type="text"
            value={filtroTexto}
            onChange={(e) => setFiltroTexto(e.target.value.toLowerCase())}
            placeholder="Nome, email ou UID"
          />
        </label>

        <label className="ordenar-usuarios">
          Ordenar por:
          <select
            value={ordenarPor}
            onChange={(e) => setOrdenarPor(e.target.value)}
          >
            <option value="pontos">Total de pontos</option>
            <option value="nome">Nome (A-Z)</option>
            <option value="data-recente">Data + recente (modo)</option>
            <option value="data-antiga">Data + antiga (modo)</option>
            <option value="porcentagem-maior">Maior % (modo)</option>
            <option value="porcentagem-menor">Menor % (modo)</option>
          </select>
        </label>

        <label className="filtro-modo">
          Filtrar por modo:
          <select
            value={modoFiltro}
            onChange={(e) => setModoFiltro(e.target.value)}
          >
            <option value="">-- Todos --</option>
            {Array.from(
              new Set(usuarios.flatMap((u) => Object.keys(u.pontosPorModo)))
            ).map((modo) => (
              <option key={modo} value={modo}>
                {modo}
              </option>
            ))}
          </select>
        </label>

        <label className="filtro-pontos">
          Pontuação mínima:
          <input
            type="number"
            value={pontosMinimos}
            onChange={(e) => setPontosMinimos(e.target.value)}
            placeholder="0"
          />
        </label>

        <label className="filtro-pontos-totais">
          Pontos totais mínimos:
          <input
            type="number"
            value={pontosTotaisMinimos}
            onChange={(e) => setPontosTotaisMinimos(e.target.value)}
            placeholder="0"
          />
        </label>

        <label className="filtro-porcentagem">
          % mínima:
          <input
            type="number"
            value={porcentagemMinima}
            onChange={(e) => setPorcentagemMinima(e.target.value)}
            placeholder="0"
          />
        </label>
      </div>

      {mensagem && <p className="mensagem">{mensagem}</p>}

      <div className="tabela-usuarios">
        {usuarios
          .filter((u) => {
            const termo = filtroTexto.trim();
            if (
              termo &&
              !(
                u.nome.toLowerCase().includes(termo) ||
                u.sobrenome.toLowerCase().includes(termo) ||
                u.email.toLowerCase().includes(termo) ||
                u.uid.toLowerCase().includes(termo)
              )
            ) {
              return false;
            }

            if (modoFiltro) {
              const dadosModo = u.pontosPorModo[modoFiltro];
              const pontos = dadosModo?.pontos ?? 0;

              if (pontos < Number(pontosMinimos || 0)) {
                return false;
              }
            }

            if (modoFiltro && porcentagemMinima) {
              const porcentagemAtual = parseFloat(
                u.pontosPorModo[modoFiltro]?.porcentagem || "0"
              );
              if (porcentagemAtual < parseFloat(porcentagemMinima)) {
                return false;
              }
            }

            if (pontosTotaisMinimos && u.total < Number(pontosTotaisMinimos)) {
              return false;
            }

            return true;
          })
          .sort((a, b) => {
            // Ordenar por nome
            if (ordenarPor === "nome") {
              return (a.nome + a.sobrenome).localeCompare(
                b.nome + b.sobrenome
              );
            }

            // Ordenar por total de pontos
            if (ordenarPor === "pontos") {
              // Quando há modoFiltro: usa pontos do modo + data do modo
              if (modoFiltro) {
                const dadosModoA = a.pontosPorModo[modoFiltro] || {};
                const dadosModoB = b.pontosPorModo[modoFiltro] || {};

                const pontosA = dadosModoA.pontos ?? 0;
                const pontosB = dadosModoB.pontos ?? 0;

                // 1. Maior pontuação primeiro
                if (pontosB !== pontosA) {
                  return pontosB - pontosA;
                }

                // 2. Se empatar, data mais antiga primeiro (dentro do modo)
                const timeA =
                  typeof dadosModoA.ultimaAtualizacao === "number"
                    ? dadosModoA.ultimaAtualizacao
                    : 0;
                const timeB =
                  typeof dadosModoB.ultimaAtualizacao === "number"
                    ? dadosModoB.ultimaAtualizacao
                    : 0;

                if (timeA !== timeB) {
                  return timeA - timeB;
                }

                // 3. Se ainda empatar, ordenar por nome
                return (a.nome + a.sobrenome).localeCompare(
                  b.nome + b.sobrenome
                );
              }

              // Sem modoFiltro: usar total geral + data mais antiga entre todos os modos
              const totalA = a.total || 0;
              const totalB = b.total || 0;

              // 1. maior total primeiro
              if (totalB !== totalA) {
                return totalB - totalA;
              }

              // 2. se empatar no total, usa a data mais antiga de todos os modos
              const earliestA = getDataMaisAntigaDeTodosOsModos(
                a.pontosPorModo
              );
              const earliestB = getDataMaisAntigaDeTodosOsModos(
                b.pontosPorModo
              );

              if (earliestA !== earliestB) {
                // menor timestamp = mais antigo
                return earliestA - earliestB;
              }

              // 3. ainda empatou? nome como desempate final
              return (a.nome + a.sobrenome).localeCompare(
                b.nome + b.sobrenome
              );
            }

            // Ordenar por data mais recente num modo
            if (ordenarPor === "data-recente" && modoFiltro) {
              const timeA =
                typeof a.pontosPorModo[modoFiltro]?.ultimaAtualizacao ===
                "number"
                  ? a.pontosPorModo[modoFiltro].ultimaAtualizacao
                  : 0;
              const timeB =
                typeof b.pontosPorModo[modoFiltro]?.ultimaAtualizacao ===
                "number"
                  ? b.pontosPorModo[modoFiltro].ultimaAtualizacao
                  : 0;
              return timeB - timeA;
            }

            // Ordenar por data mais antiga num modo
            if (ordenarPor === "data-antiga" && modoFiltro) {
              const timeA =
                typeof a.pontosPorModo[modoFiltro]?.ultimaAtualizacao ===
                "number"
                  ? a.pontosPorModo[modoFiltro].ultimaAtualizacao
                  : 0;
              const timeB =
                typeof b.pontosPorModo[modoFiltro]?.ultimaAtualizacao ===
                "number"
                  ? b.pontosPorModo[modoFiltro].ultimaAtualizacao
                  : 0;
              return timeA - timeB;
            }

            // Maior porcentagem num modo
            if (ordenarPor === "porcentagem-maior" && modoFiltro) {
              const porcA = parseFloat(
                a.pontosPorModo[modoFiltro]?.porcentagem || "0"
              );
              const porcB = parseFloat(
                b.pontosPorModo[modoFiltro]?.porcentagem || "0"
              );
              return porcB - porcA;
            }

            // Menor porcentagem num modo
            if (ordenarPor === "porcentagem-menor" && modoFiltro) {
              const porcA = parseFloat(
                a.pontosPorModo[modoFiltro]?.porcentagem || "0"
              );
              const porcB = parseFloat(
                b.pontosPorModo[modoFiltro]?.porcentagem || "0"
              );
              return porcA - porcB;
            }

            // Fallback: total geral
            return (b.total || 0) - (a.total || 0);
          })
          .map((u, index) => {
            const posicao = index + 1;

            return (
              <div key={u.uid} className="linha-usuario">
                <div className="posicao-usuario">#{posicao}</div>

                <div className="info-usuario">
                  <strong>
                    {u.nome} {u.sobrenome}
                  </strong>
                  <p>UID: {u.uid}</p>
                  <p>Email: {u.email}</p>
                  <p>Total: {u.total}</p>

                  <div className="selado">
                    {u.selos.length > 0 ? (
                      <p>Selos: {u.selos.join(", ")}</p>
                    ) : (
                      <p>Selos: Nenhum</p>
                    )}
                  </div>

                  <div className="modos">
                    {Object.entries(u.pontosPorModo).map(([modo, dados]) => {
                      const pontos = dados?.pontos ?? 0;
                      const porcentagemRaw = dados?.porcentagem;
                      const porcentagem = !isNaN(
                        parseFloat(porcentagemRaw)
                      )
                        ? parseFloat(porcentagemRaw).toFixed(1)
                        : "0.0";

                      const data =
                        typeof dados.ultimaAtualizacao === "number"
                          ? new Date(dados.ultimaAtualizacao).toLocaleString(
                              "pt-PT",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit"
                              }
                            )
                          : null;

                      return (
                        <span key={modo}>
                          {modo}: {pontos} pts · {porcentagem}%
                          {data && (
                            <span className="data-atualizacao2">
                              {" "}
                              ({data})
                            </span>
                          )}
                        </span>
                      );
                    })}
                  </div>
                </div>

                <button onClick={() => atribuirSelo(u.uid)}>
                  <img
                    src="https://i.imgur.com/DD7Wx9l.png"
                    alt="Ícone selo"
                    style={{
                      width: 16,
                      height: 16,
                      marginRight: 6,
                      verticalAlign: "middle"
                    }}
                  />
                  Atribuir selo
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default UsuariosESelos;

